import { BaseTracking } from "app/core/tracking/base-tracking";
import { API } from "./xapi/api.service";
import { Logger } from "../../helpers/Logger";
import { HttpService } from "../../services/http.service";
import { UtilityScripts } from "../../helpers/utility-scripts";
import { AppServices } from "app/app.services";
import { Subscription } from "rxjs";
import { LaunchURLVO } from "./xapi/launchurlvo";

export class XAPI extends BaseTracking {
	private httpService: HttpService;
	private appService: AppServices;
	private configVO: any;
	private launchURLVO: LaunchURLVO;
	private courseCompletedSubscription: Subscription;
	private _isTerminated: boolean = false;
	private api: API;

	public init(
		configVO: any,
		_httpService: HttpService = null,
		appService: AppServices = null
	) {
		super.init(configVO);
		this.httpService = _httpService;
		this.appService = appService;
		this.configVO = configVO;
		this.courseCompletedSubscription =
			this.appService.courseCompleted$.subscribe((event) =>
				this.courseCompletedHandler()
			);
	}
	public async doInitialize() {
		let launch_URL = document.location.search;
		this.launchURLVO = this.setLaunchURLVO(launch_URL);
		console.log("this.launchURLVO   ", this.launchURLVO);
		this.handleInitialized();
	}
	private async handleInitialized() {
		this.api = new API(
			this.httpService,
			this.launchURLVO,
			this.getLaunchURLVO().auth
		);
		await this.setTrackingData();
		this.notifyInitialize();
		this.appService.trackingManagerInitilaized();
	}
	private async setTrackingData() {
		let res_location = await this.api.getState(
			"lesson_location",
			this.getQueryString()
		);
		let res_suspenddata = await this.api.getState(
			"suspend_data",
			this.getQueryString()
		);
		let res_lessonStatus = await this.api.getState(
			"lesson_status",
			this.getQueryString()
		);
		let res_adaptive_reporting = await this.api.getState(
			"adaptive_reporting",
			this.getQueryString()
		);

		if (res_adaptive_reporting != null) {
			this.trackingVO.attempts = JSON.parse(
				res_adaptive_reporting._body
			).adaptive_reporting.attempts;
			this.trackingVO.failure = JSON.parse(
				res_adaptive_reporting._body
			).adaptive_reporting.failure;
			this.trackingVO.totalScore = JSON.parse(
				res_adaptive_reporting._body
			).adaptive_reporting.totalScore;
		}
		let statements;
		this.trackingVO.lessonLocation =
			res_location && res_location._body
				? JSON.parse(res_location._body).lesson_location
				: null;
		if (res_location != null) {
			this.trackingVO.lessonLocation = JSON.parse(
				res_location._body
			).lesson_location;
		}
		if (res_suspenddata != null) {
			this.parseSuspenddata(JSON.parse(res_suspenddata._body).suspend_data);
		}
		if (res_lessonStatus != null) {
			this.trackingVO.lessonStatus = JSON.parse(
				res_lessonStatus._body
			).lesson_status;
		} else {
			this.trackingVO.lessonStatus = "i";
		}
		this.trackingVO.studentName = JSON.parse(this.getLaunchURLVO().actor)[
			"name"
		]
			? JSON.parse(this.getLaunchURLVO().actor)["name"]
			: JSON.parse(this.getLaunchURLVO().actor)["account"]["name"];
		await this.api.sendStatements(this.createStatement("initialized"));
		await this.api.sendStatements(this.createStatement("attempted"));
	}
	//
	private parseSuspenddata(rawData: string) {
		rawData = UtilityScripts.dataEscapeUnescape(
			rawData,
			"unescape",
			this.escapeCount
		);
		let lines: Array<string> = rawData.split("&");
		for (let l in lines) {
			if (lines[l].indexOf(">") > 0) {
				let assigns: Array<string> = lines[l].split(">");
				//Logger.log(l,lines[l],assigns,Number(assigns[1]),parseInt(assigns[1]))
				if (assigns[0] === "score") {
					this.trackingVO.score = parseInt(assigns[1]);
				} else if (assigns[0] === "geolocation") {
					this.trackingVO.geoLocation = assigns[1];
				} else {
					this.trackingVO[assigns[0]] = assigns[1];
				}
				//Logger.log( 4, 'this.trackingVO.' , assigns[ 0 ] , ' = ' , assigns[ 1 ] );
			}
		}
		/* ------- Below code is added to handle the error in case the 'elt_total_time' is not in correct format (i.e. 0000:00:00.00) --------------*/
		if (
			rawData != "" &&
			rawData != "undefined" &&
			rawData != undefined &&
			rawData != null
		) {
			this.trackingVO["elt_total_time"] = UtilityScripts.resolveTime(
				this.trackingVO["elt_total_time"].split(".")[0]
			);
		}
		/* ----------------------------------------------------------------------------------------------------------------*/
	}

	private async courseCompletedHandler() {
		await this.api.sendStatements(this.createStatement("completed"));
	}

	public doCommit() {
		this.saveData();
		return true;
	}

	private async saveData() {
		if (this.strOrigStatus === this.completedVal) {
			this.trackingVO.lessonStatus = this.completedVal;
		}
		let adaptive_reporting: any = {};
		adaptive_reporting.totalScore = this.trackingVO.totalScore;
		let suspend_data: string = this.formSuspendData();
		let lessonLocation: any = await this.api.sendState(
			"lesson_location",
			{ lesson_location: this.trackingVO.lessonLocation },
			this.getQueryString()
		);
		let suspendData: any = await this.api.sendState(
			"suspend_data",
			{ suspend_data: suspend_data },
			this.getQueryString()
		);
		let lessonStatus: any = await this.api.sendState(
			"lesson_status",
			{ lesson_status: this.trackingVO.lessonStatus },
			this.getQueryString()
		);
		//let adaptiveReporting = await this.api.sendState('adaptive_reporting', {'adaptive_reporting':adaptive_reporting},this.getQueryString());

		//await this.api.sendStatements(this.createStatement("reporting"));
	}

	public async doFinish() {
		await this.saveAndExit();
		return true;
	}

	public async saveAndExit() {
		await this.saveData();
		await this.exitCourse();
	}

	public async exitCourse() {
		await this.api.sendStatements(this.createStatement("terminated"));
		this.api.isTerminated = true;
		//window.parent.close();
		return true;
	}

	private formSuspendData() {
		let suspend_data: string = "bookmark>" + this.trackingVO["bookmark"] + "&";
		suspend_data +=
			"completion_date>" + this.trackingVO["completionDate"] + "&";
		suspend_data +=
			"elt_total_time>" +
			UtilityScripts.resolveTime(this.trackingVO["totalTime"]); // + '&otherstuff>' + otherstuff
		// Save other suspend_data fields
		if (this.trackingVO.geoLocation != null) {
			suspend_data += "&geolocation>" + this.trackingVO.geoLocation;
		}
		if (this.trackingVO.score > 0) {
			suspend_data += "&score>" + this.trackingVO.score;
		}
		if(this.trackingVO.rubricStatus) {
			suspend_data += '&rubricStatus>' + this.trackingVO.rubricStatus;
		}
		suspend_data = UtilityScripts.dataEscapeUnescape(
			suspend_data,
			"escape",
			this.escapeCount
		); // this code line was commented in earlier version
		Logger.log(
			4,
			"suspend_data =============================================================" +
				suspend_data
		);
		console.log("formSuspendData = " + suspend_data);
		return suspend_data;
	}

	private getTimeStamp() {
		return new Date();
	}

	public async answeredStatement(page_id, mcq, selectedOptions, result) {
		await this.api.sendStatements(
			this.createStatement("answered", page_id, mcq, selectedOptions, result)
		);
	}

	private createStatement(
		verb: any,
		page_id = "",
		mcq = null,
		selectedOptions = null,
		result = false
	) {
		this.trackingVO.sessionTime = UtilityScripts.resolveTime(
			this.trackingVO.sessionTime
		);

		let duration = UtilityScripts.convertMillisecondsToISO8601Duration(
			UtilityScripts.convertToMS(this.trackingVO.sessionTime)
		);
		let completed =
			this.trackingVO.lessonStatus == this.completedVal ? true : false;
		let _statement = {
			id: "",
			actor: JSON.parse(this.getLaunchURLVO().actor),
			verb: {
				id: "http://adlnet.gov/expapi/verbs/" + verb,
				display: {
					"en-US": verb,
				},
			},
			result: {},
			timestamp: this.getTimeStamp(),
			object: {
				id: this.getLaunchURLVO().activity_id,
				objectType: "Activity",
				definition: this.getDefination(
					verb,
					page_id,
					mcq,
					selectedOptions,
					result
				),
			},
			context: this.getContext(),
		};
		if (verb == "completed") {
			_statement.result = {
				/*score: {
                scaled: 1,
                raw: 100,
                min: 0,
                max: 100
            },
            success: true,*/
				completion: completed,
				duration: duration,
			};
		} else if (verb == "attempted" || verb == "experienced") {
			_statement.result = {
				completion: completed,
				duration: duration,
			};
		}
		return _statement;
	}

	private getDefination(verb: any, page_id, mcq, selectedOptions, result) {
		{
			if (verb == "answered") {
				let choices: Array<string> = [];
				let correctAnswers: Array<string> = [];
				mcq.choices.forEach((choice) => {
					if (choice.correct) correctAnswers.push(choice.label);

					choices.push(choice.label);
				});
				return {
					extensions: {
						"http://adlnet.gov/expapi/questionId": "Question ID 1011",
						"http://adlnet.gov/expapi/question": mcq.question,
						"http://adlnet.gov/expapi/instruction": mcq.instruction,
						"http://adlnet.gov/expapi/choices": choices,
						"http://adlnet.gov/expapi/correctAnswers": correctAnswers,
					},
				};
			} else {
				return {
					extensions: {
						"http://adlnet.gov/expapi/penmanName": this.trackingVO.penmanName,
						"http://adlnet.gov/expapi/courseTopic": this.trackingVO.courseTopic,
						"http://adlnet.gov/expapi/learningType":
							this.trackingVO.learningType,
						"http://adlnet.gov/expapi/complianceTypeID":
							this.trackingVO.complianceTypeID,
						"http://adlnet.gov/expapi/complianceTypeName":
							this.trackingVO.complianceTypeName,
						"http://adlnet.gov/expapi/moduleVersion":
							this.trackingVO.moduleVersion,
						"http://adlnet.gov/expapi/accessabilityOption":
							this.trackingVO.accessabilityOption,
						"http://adlnet.gov/expapi/moduleShortname":
							this.trackingVO.moduleShortname,
						"http://adlnet.gov/expapi/attempts": this.trackingVO.attempts,
						"http://adlnet.gov/expapi/failure": this.trackingVO.failure,
					},
				};
			}
		}
	}
	private getQueryString() {
		const query =
			"agent=" +
			encodeURIComponent(this.getLaunchURLVO().actor) +
			"&activityId=" +
			encodeURIComponent(this.getLaunchURLVO().activity_id) +
			"&registration=" +
			encodeURIComponent(this.getLaunchURLVO().registration) +
			"&content_token=" +
			encodeURIComponent(this.getLaunchURLVO().content_token) +
			"&content_endpoint=" +
			encodeURIComponent(this.getLaunchURLVO().content_endpoint) +
			"&externalConfiguration=" +
			encodeURIComponent(this.getLaunchURLVO().externalConfiguration) +
			"&externalRegistration=" +
			encodeURIComponent(this.getLaunchURLVO().externalRegistration) +
			"&width=" +
			encodeURIComponent(this.getLaunchURLVO().width) +
			"&height=" +
			encodeURIComponent(this.getLaunchURLVO().height) +
			"&left=" +
			encodeURIComponent(this.getLaunchURLVO().left) +
			"&top=" +
			encodeURIComponent(this.getLaunchURLVO().top);
		return query;
	}
	//
	private getContext() {
		return {
			contextActivities: {
				category: [
					{
						definition: {
							type: this.getLaunchURLVO().content_endpoint,
						},
						id: this.getLaunchURLVO().activity_id,
						objectType: "Activity",
					},
					{
						definition: {
							type: this.getLaunchURLVO().content_endpoint,
							description: {
								"en-US": "An e-learning course",
							},
							name: {
								"en-US": "E-learning course",
							},
						},
						id: this.getLaunchURLVO().activity_id,
						objectType: "Activity",
					},
				],
				grouping: [
					{
						id: this.getLaunchURLVO().grouping,
						objectType: "Activity",
					},
					{
						id: "http://id.tincanapi.com/activity/tincan",
						objectType: "Activity",
					},
				],
				parent: [
					{
						id: "http://id.tincanapi.com/activity/tincan/navex",
						objectType: "Activity",
					},
				],
			},
			registration: this.getLaunchURLVO().registration,
		};
	}

	private setLaunchURLVO(strUrl: any): LaunchURLVO {
		const launchVO: LaunchURLVO = new LaunchURLVO();
		const arrUrlvariables = strUrl.substr(1).split("&");

		for (let item of arrUrlvariables) {
			const item_split = item.split("=", 2);
			if (item_split.length != 2) continue;
			launchVO[item_split[0]] = decodeURIComponent(
				item_split[1].replace(/\+/g, " ")
			);
			launchVO[item_split[0]] = launchVO[item_split[0]].replace(/\[/g, " ");
			launchVO[item_split[0]] = launchVO[item_split[0]].replace(/\]/g, " ");
			if (item_split[0] == "actor") {
				let tmpJSON = JSON.parse(launchVO[item_split[0]]);
				let obj = {
					objectType: tmpJSON.objectType,
					account: {
						name: tmpJSON.account.accountName,
						homePage: tmpJSON.account.accountServiceHomePage,
					},
					name: tmpJSON.name,
				};
				launchVO[item_split[0]] = JSON.stringify(obj);
			}
		}
		launchVO.endpoint = UtilityScripts.stripTrailingSlash(launchVO.endpoint);
		return launchVO;
	}

	public getLaunchURLVO() {
		return this.launchURLVO;
	}
}
